import * as SiteSearchForm from './components/SearchFormSite/SearchFormSite.css';
var siteSearchForm = {
    SearchForm: {
        SearchForm: {
            searchForm: SiteSearchForm.searchForm__searchForm,
            row: SiteSearchForm.searchForm__row
        },
        Bottom: {
            bottom: SiteSearchForm.bottom__bottom,
            controls: SiteSearchForm.bottom__controls
        },
        MultiCity: {
            caption: SiteSearchForm.multiCity__caption
        },
        OfferHotels: {
            toggle_active: SiteSearchForm.offerHotels__toggleActive,
            toggle__label: SiteSearchForm.offerHotels__toggleLabel
        },
        Controls: {
            controls: SiteSearchForm.controls__controls,
            controls_multiCity: SiteSearchForm.controls__controlsMultiCity
        }
    },
    Switch: {
        Switch: {
            wrapper: SiteSearchForm.switch__wrapper
        }
    }
};
export default siteSearchForm;
